import React, { useState, useMemo, useEffect, useCallback } from "react";
import MDBox from "components/MDBox";
import RouteReplayMap from "./components/routeReplayMap";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import FilterCard from "./components/filterCard";
import HistoryCard from "./components/historyCard";
import { IconButton } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useSelector, useDispatch } from "react-redux";
import SpeedAnalysis from "./components/speedAnalysis";
import left from "../../assets/images/left.png";
import right from "../../assets/images/right.png";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import axios from "axios";

function RouteReplay() {
  const [collapsed, setCollapsed] = useState(false);
  const [isTripDrawerOpen, setIsTripDrawerOpen] = useState(false);
  const dispatch = useDispatch();

  const [speedThresholds, setSpeedThresholds] = useState({
    low: 30,
    med: 60,
    high: 90
  });

  // Fetching org ID
  const accountData = useSelector((state) => state.account?.data?.accountModel?.account);
  const currentOrgId = 
    accountData?.orgHandle || 
    accountData?.orgId || 
    localStorage.getItem("orgtype"); 

  // GET API Call Function
  const fetchSpeedThresholds = useCallback(async () => {
    const token = localStorage.getItem("token");

    if (!token || !currentOrgId) return;

    try {
      const response = await axios.get(`https://v3.dhundhoo.com/org/${currentOrgId}/speedThresholds`, {
        headers: {
          "x-dhundhoo-session": token,
          "orgHandle": currentOrgId
        }
      });

      const resData = response.data;
      
      // NAYA LOGIC: Extracting thresholds from object keys
      if (resData?.speedExceeded) {
        // Step 1: Object ke keys extract karo (["0", "40", "50", "70"])
        // Step 2: Unhe Numbers mein convert karke sort karo ([0, 40, 50, 70])
        const extractedKeys = Object.keys(resData.speedExceeded)
          .map(Number)
          .filter(val => !isNaN(val))
          .sort((a, b) => a - b);

        if (extractedKeys.length >= 4) {
          setSpeedThresholds({
            low: extractedKeys[1],
            med: extractedKeys[2],
            high: extractedKeys[3]
          });
          console.log("Successfully Applied GET API Thresholds:", extractedKeys);
        }
      } 
      // Fallback in case backend returns the array format later
      else if (resData?.speedThresholds && Array.isArray(resData.speedThresholds)) {
        const apiThresholds = resData.speedThresholds;
        if (apiThresholds.length >= 4) {
          setSpeedThresholds({
            low: Number(apiThresholds[1]),
            med: Number(apiThresholds[2]),
            high: Number(apiThresholds[3])
          });
        }
      }
    } catch (err) {
      console.error("Error fetching GET API:", err);
    }
  }, [currentOrgId]);

  // Initial Load Par Call
  useEffect(() => {
    if (currentOrgId) {
      fetchSpeedThresholds();
    }
  }, [currentOrgId, fetchSpeedThresholds]);

  const devices = useSelector((state) => state.routeReplay.devices);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const sidebarWidth = 430;

  const devicePackets = useMemo(() => {
    if (!devices || !devices.devices) return [];
    return Object.entries(devices.devices)
      .filter(([key]) => !isNaN(key))
      .map(([timestamp, data]) => ({ timestamp: Number(timestamp), ...data }))
      .sort((a, b) => a.timestamp - b.timestamp);
  }, [devices]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        sx={{
          display: "flex",
          height: "calc(100vh - 75px)",
          overflow: "hidden",
          position: "relative",
          p: 1,
        }}
      >
        <MDBox
          sx={{
            position: "absolute",
            top: 10,
            left: collapsed ? `-${sidebarWidth + 20}px` : 10,
            borderRadius: "24px",
            width: `${sidebarWidth}px`,
            height: "calc(100% - 20px)",
            background: "white",
            boxShadow: "2px 0 6px rgba(0,0,0,0.1)",
            zIndex: 12,
            overflowY: "auto",
            transition: "left 0.3s ease-in-out",
            "&::-webkit-scrollbar": { display: "none" },
            msOverflowStyle: "none",
            scrollbarWidth: "none",
          }}
        >
          <FilterCard
            speedThresholds={speedThresholds}
            setSpeedThresholds={setSpeedThresholds}
            onClearTable={() => setIsTripDrawerOpen(false)}
          />
          {devicePackets.length > 0 && (
            <MDBox>
              <HistoryCard />
              <SpeedAnalysis 
                thresholds={speedThresholds} 
                setThresholds={setSpeedThresholds} 
                onDrawerStateChange={setIsTripDrawerOpen}
                isInsideSidebar={true}
                fetchSpeedThresholds={fetchSpeedThresholds} 
              />
            </MDBox>
          )}
        </MDBox>

        <IconButton
          onClick={() => setCollapsed(!collapsed)}
          sx={{
            position: "absolute",
            top: "20px",
            left: collapsed ? "20px" : "470px",
            zIndex: 15,
            borderRadius: "50%",
            minWidth: "40px",
            width: "40px",
            height: "40px",
            padding: 0,
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
            backgroundColor: "white !important",
            color: "black",
            transition: "left 0.3s ease-in-out",
          }}
        >
          {collapsed ? (
            <img
              src={right}
              alt="right-arrow"
              style={{ width: isMobile ? "18px" : "24px", height: isMobile ? "18px" : "24px", cursor: "pointer", transition: "filter 0.2s" }}
            />
          ) : (
            <img
              src={left}
              alt="close"
              style={{ cursor: "pointer", width: "24px", height: "24px", transition: "filter 0.2s" }}
            />
          )}
        </IconButton>
        
        <MDBox
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            marginLeft: collapsed ? "0px" : `${sidebarWidth + 20}px`,
            height: "100%",
            transition: "margin-left 0.3s ease-in-out",
            gap: 1.5
          }}
        >
          <MDBox
            sx={{
              flex: isTripDrawerOpen ? "0 0 50%" : "1",
              borderRadius: "24px",
              overflow: "hidden",
              transition: "flex 0.4s ease-in-out",
              boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
            }}
          >
            <RouteReplayMap thresholds={speedThresholds} />
          </MDBox>

          {isTripDrawerOpen && (
            <SpeedAnalysis
              thresholds={speedThresholds} 
              setThresholds={setSpeedThresholds}
              onDrawerStateChange={setIsTripDrawerOpen}
              isInsideSidebar={false}
              fetchSpeedThresholds={fetchSpeedThresholds} 
            />
          )}
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
}

export default RouteReplay;